export const DepositStatus = {
        REQUESTED:"درخواست شده",
        BANK_PENDING:"در انتظار بانک",
        CONFIRMED:"تایید شده",
        REJECTED:"رد شده"
}
